export const maskEmail = (email: string): string => {
  return email.replace(
    /^(.{2})(.+)(@)(.+)(\.[^.]+)$/,
    (_, v, local, at, _domain, tld) => v + '*'.repeat(local.length) + at + '**' + tld
  )
}
